import { useCallback } from 'react';

/**
 * Handlers for deliverable submit/edit/clear modals used by view props.
 */
const useDeliverableHandlers = ({
  tasks,
  actions,
  setDeliverableSubmitModal,
  setDeliverablesModalTaskId,
}) => {
  // Handler for opening deliverable submit modal from status dropdown warning
  const handleSubmitDeliverable = useCallback((taskId, taskName, deliverable) => {
    setDeliverableSubmitModal({
      isOpen: true,
      taskId,
      taskName: taskName || 'Mission',
      deliverable,
    });
  }, [setDeliverableSubmitModal]);

  // Handler for opening deliverables edit modal (from conditions modal)
  const handleEditDeliverables = useCallback((taskId) => {
    setDeliverablesModalTaskId(taskId);
  }, [setDeliverablesModalTaskId]);

  // Handler for clearing a deliverable submission (from conditions modal)
  // Note: Uses actions directly since wrappedActions only wraps handleConditionsChange
  const handleClearDeliverable = useCallback((taskId, deliverableId) => {
    const task = tasks.find(t => t.id === taskId);
    const currentDeliverables = task?.deliverables || [];
    const updated = currentDeliverables.map(d =>
      d.id === deliverableId
        ? { ...d, completed: false, link: undefined, submittedFilename: undefined, attachmentId: undefined }
        : d
    );
    actions.handleDeliverablesChange(taskId, updated);
  }, [tasks, actions]);

  return {
    handleSubmitDeliverable,
    handleEditDeliverables,
    handleClearDeliverable,
  };
};

export default useDeliverableHandlers;
